<template>
	<div class="container">
		<h2>Edit Role</h2>
		<div>
			<router-link to="/roles" class="btn btn-link">
				<i class="fas fa-arrow-left"></i> Back to Roles List
			</router-link>
		</div>
		<form @submit.prevent="submitForm" class="form-horizontal col-sm-6">
			<div class="form-group row">
				<label for="code" class="col-sm-4 col-form-label text-right">Code *</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" id="code" v-model="role.code" required>
				</div>
			</div>
			<div class="form-group row">
				<label for="description" class="col-sm-4 col-form-label text-right">Description *</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" id="description" v-model="role.description" required>
				</div>
			</div>
			<div class="form-group row">
				<label for="permissions" class="col-sm-4 col-form-label text-right">Permissions</label>
				<div class="col-sm-8">
					<div v-for="permission in allPermissions" :key="permission" class="form-check">
						<input
							type="checkbox"
							class="form-check-input"
							:id="permission"
							:value="permission"
							v-model="selectedPermissions">
						<label class="form-check-label" :for="permission">{{ permission }}</label>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label for="status" class="col-sm-4 col-form-label text-right">Status *</label>
				<div class="col-sm-8">
					<select class="form-control" id="status" v-model="role.active">
						<option :value="true">Active</option>
						<option :value="false">Inactive</option>
					</select>
				</div>
			</div>
			<div class="form-group row">
				<div class="col-sm-8 offset-sm-4">
					<button type="submit" class="btn btn-primary">
                        <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
						Save
                    </button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';

export default {
	data() {
		return {
			role: {
				code: '',
				description: '',
				permissions: '',
				active: true
			},
			selectedPermissions: [],
			allPermissions: [],
            loading: false
		};
	},
	async mounted() {
		if (!(await checkAuth())) {
			eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
			this.$router.push('/');
		} else {
			await this.fetchPermissions();
			await this.fetchRole();
		}
	},
	methods: {
		async fetchRole() {
			try {
				const response = await api.get(`/v1/roles/${this.$route.params.roleId}`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem('accessToken')}`
					}
				});

				if (response.status === 200) {
					const role = response.data.data.role;
					// Pre-check the permissions checkboxes by splitting the permissions string into an array
					this.selectedPermissions = role.permissions ? role.permissions.split(',') : [];
					this.role = role;
				} else {
					eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
				}
			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
				}
			}
		},
		async fetchPermissions() {
			try {
				const response = await api.get('/v1/permissions', {
					headers: {
						Authorization: `Bearer ${localStorage.getItem('accessToken')}`
					}
				});

				if (response.status === 200) {
					this.allPermissions = response.data.data.permissions.sort((a, b) => a.localeCompare(b));
				} else {
					eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
				}
			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
				}
			}
		},
		async submitForm() {
            this.loading = true;
			if (!(await checkAuth())) {
                eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
                this.$router.push('/');
            } else {
				try {
					// Clear the permissions field first
					this.role.permissions = '';
					// Update it with the comma-separated list of selected permissions
					this.role.permissions = this.selectedPermissions.join(',');
					console.log('Role to save:', this.role);

					const response = await api.put(`/v1/roles/${this.$route.params.roleId}`, this.role, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem('accessToken')}`
						}
					});

					if (response.status === 200) {
						eventBus.emit('show-alert', { message: response.data.message, type: 'success' });
						this.$router.push('/roles');
					} else {
						eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
					}
				} catch (err) {
					console.error(err);
					if (err.response) {
						console.error(err.response.data);
						eventBus.emit('show-alert', { message: err.response.data.message, type: 'danger' });
					}
				}
			}
            this.loading = false;
		}
	}
};
</script>

<style>
.form-horizontal .form-group {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
</style>
